module.exports = __webpack_public_path__ + "static/media/tailwindcss-logo.760a3ee4.svg";